const ScoreCircle = ({ actual, goal, label, color }) => {
  // background color logic
  let bgColor = "#d1dbcf"; // default green
  if (color === "red") bgColor = "#fca5a5";
  if (color === "gray") bgColor = "#e5e7eb";

  return (
    <div className="flex flex-col items-center mb-2">
      {/* Label */}
      <p className="mb-2 head-4 dark-H text-center">{label}</p>

      {/* Circle */}
      <div className="w-24 h-24 rounded-full border border-gray-400 overflow-hidden shadow">

        {/* Top Half */}
        <div
          className="h-1/2 flex items-center justify-center"
          style={{ backgroundColor: bgColor }}
        >
          <span className="head-4 font-semibold leading-tight translate-y-[1px]">
            {actual}
          </span>
        </div>

        {/* Divider */}
        <div className="border-t border-black" />

        {/* Bottom Half */}
        <div
          className="h-1/2 flex items-center justify-center"
          style={{ backgroundColor: bgColor }}
        >
          <span className="head-4 font-semibold leading-tight -translate-y-[1px]">
            {goal}
          </span>
        </div>

      </div>
    </div>
  );
};

export default ScoreCircle;
